<template>
  <Card
    v-bind="$attrs"
    clickable
    :morph="drawing.timeline_morph"
    :pinned="drawing.timeline_pinned"
    :simple="simple"
    @click="viewingDrawingID = drawing.id"
  >
    <q-item-section>
      <div class="text-caption text-bold q-mb-xs">
        <span v-if="fullDate" class="q-pr-xs">
          ({{ $formatSystemDate(drawing.timeline_date, luxonFormats.SHORT_WORDED_DATE) }})
        </span>
        Drawing
      </div>

      <q-item
        class="invisible-item q-px-xs"
      >
        <q-item-section
          v-if="drawing.signed_thumbnail_url"
          side
          class="q-pr-sm"
        >
          <q-avatar
            rounded
            :size="`${windowWidth < 768 ? 40 : 75}px`"
          >
            <img
              class="checkerboard shadow-2"
              style="max-width: 100%; max-height: 100%; width: auto; height: auto;"
              :src="drawing.signed_thumbnail_url"
            />
          </q-avatar>
        </q-item-section>

        <q-item-section>
          <q-item-label class="text-bold">
            {{ drawing.title }}
          </q-item-label>
          <q-item-label caption>
            {{ drawing.reference_id }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-item-section>
  </Card>

  <ViewDrawingDialog
    :id="viewingDrawingID"
    @close="viewingDrawingID = null"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

import Card from 'components/partials/timeline/partials/Card'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card,
    ViewDrawingDialog: defineAsyncComponent(() => import('src/components/app/drawings/partials/ViewDrawingDialog.vue'))
  },
  mixins: [cardMixin],
  props: {
    drawing: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewingDrawingID: null
    }
  }
}
</script>
